var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProposals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 91,
    viewBox: "0 0 65 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 emoji \"ring\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.4104 26.4643L53.0012 11.6899L47.4312 0.410156H17.3573L11.7859 11.6899L26.3782 26.4643C11.5797 29.3237 0.354141 42.4968 0.354141 58.29C0.354141 76.1676 14.7282 90.7086 32.3935 90.7086C50.0589 90.7086 64.4329 76.1676 64.4329 58.29C64.4329 42.4968 53.2073 29.3222 38.4104 26.4643ZM34.4719 19.4857H30.2911L28.1059 12.8608H36.6556L34.4719 19.4857ZM45.6208 3.32379L48.8926 9.94868H39.9094L38.8303 3.32379H45.6208ZM39.7243 12.8608H47.7518L41.2052 19.4857H37.5406L39.7243 12.8608ZM28.905 3.32379H35.8791L36.9581 9.94868H27.8079L28.905 3.32379ZM19.1663 3.32379H25.9538L24.8566 9.94868H15.8945L19.1663 3.32379ZM17.0308 12.8608H25.0387L27.2224 19.4857H23.5548L17.0308 12.8608ZM32.3935 87.795C16.3325 87.795 3.26627 74.5587 3.26627 58.29C3.26627 42.0212 16.334 28.7834 32.3935 28.7834C48.4531 28.7834 61.5193 42.0197 61.5193 58.29C61.5193 74.5602 48.4546 87.795 32.3935 87.795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.3936 32.1768C18.161 32.1768 6.58025 43.8915 6.58025 58.2896C6.58025 72.6892 18.161 84.4039 32.3936 84.4039C46.6261 84.4039 58.2069 72.6907 58.2069 58.2896C58.2069 43.8915 46.6261 32.1768 32.3936 32.1768ZM32.3936 81.4902C19.7653 81.4902 9.49237 71.0818 9.49237 58.2896C9.49237 45.4973 19.7668 35.0889 32.3936 35.0889C45.0203 35.0889 55.2933 45.4973 55.2933 58.2896C55.2933 71.0818 45.0218 81.4902 32.3936 81.4902Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposals);
export default __webpack_public_path__ + "static/media/proposals.64aba2edf7f0f2c50a130520bea5dba4.svg";
export { ForwardRef as ReactComponent };